//@flow
import React from 'react';
import TimeSlots from 'common/entity/components/slot/TimeSlots';

export class MultiDayWeekSlot extends React.PureComponent {
    render() {
        const {
            timeSlot,
            selectedDays,
            theme,
            t,
            onDelete,
            onChange,
            onCopyToAllClick,
            onAddSlotClick,
            onToggleDaySelection
        } = this.props;
        const { slots, dayOfWeek } = timeSlot;
        return (
            <TimeSlots
                slots={slots}
                dayOfWeek={dayOfWeek}
                selectedDays={selectedDays}
                theme={theme}
                t={t}
                onDelete={onDelete}
                onChange={onChange}
                onCopyToAllClick={onCopyToAllClick}
                onAddSlotClick={onAddSlotClick}
                onToggleDaySelection={onToggleDaySelection}
            />
        );
    }
}

export default MultiDayWeekSlot;
